<template>
 <main class="html-page home-page contact-page">
<main><section class="page-hero contact-hero" data-bloco="contato-hero" data-tipo="hero"><div class="container contact-hero-grid"><div class="contact-hero-copy"><h1 data-campo="iti_resumo1" v-html="html(contatoHero, 'iti_resumo1')"></h1><p data-campo="iti_descricao1" v-html="html(contatoHero, 'iti_descricao1')"></p><a class="btn btn-primary" v-html="html(contatoHero, 'iti_texto_btn1')" :href="link(contatoHero, 'iti_link_btn1')"></a></div><div class="contact-hero-media"><img v-if="image(contatoHero)" alt="Veterinária atendendo pelo celular com um cão" data-img="imagem" :src="image(contatoHero)" @error="hideBrokenImage"></div></div></section>
<section class="section contact-section" data-bloco="contato-formulario" data-tipo="formulario"><div class="container contact-modern-layout"><div class="contact-info"><p class="eyebrow">ATENDIMENTO</p><h2 data-campo="iti_nome" v-html="html(contatoFormulario, 'iti_nome')"></h2><p data-campo="iti_resumo1" v-html="html(contatoFormulario, 'iti_resumo1')"></p><div class="contact-info-list"><a :href="addressMapLink" target="_blank" rel="noopener"><span aria-hidden="true">⌖</span><div><strong>Endereço</strong><small data-campo="iti_campoextra1" v-html="html(contatoFormulario, 'iti_campo_extra1')"></small></div></a><a :href="phoneHref"><span aria-hidden="true">☎</span><div><strong>Telefones</strong><small data-campo="iti_campoextra3" v-html="html(contatoFormulario, 'iti_campo_extra3')"></small></div></a><a :href="whatsappHref" target="_blank" rel="noopener"><span aria-hidden="true">◉</span><div><strong>WhatsApp</strong><small data-campo="iti_campoextra4" v-html="html(contatoFormulario, 'iti_campo_extra4')"></small></div></a></div></div><form class="contact-form contact-modern-form" @submit.prevent="submitContact"><div class="form-heading"><span class="eyebrow">ENVIE UMA MENSAGEM</span><h2>Como podemos ajudar?</h2></div><label>Nome<input type="text" placeholder="Seu nome" required v-model="form.nome"></label><label>E-mail<input type="email" placeholder="seu@email.com" v-model="form.email" required></label><label>Telefone<input type="tel" placeholder="(00) 00000-0000" required v-model="form.whatsapp"></label><label>Assunto<select v-model="form.interesse"><option>Agendamento de exame</option><option>Informações sobre preparo</option><option>Dúvidas</option><option>Outro assunto</option></select></label><label class="full">Mensagem<textarea rows="5" placeholder="Conte brevemente como podemos ajudar..." v-model="form.mensagem"></textarea></label><button class="btn btn-primary" type="submit">{{ sending ? 'Enviando...' : 'Enviar mensagem' }}</button><p v-if="successMessage" class="form-success">{{ successMessage }}</p><p v-if="errorMessage" class="form-error">{{ errorMessage }}</p></form></div></section><section v-if="contactAddress" class="section soft contact-map-section"><div class="container"><div class="section-head"><div><p class="eyebrow">COMO CHEGAR</p><h2>Estamos no Menino Deus.</h2></div><p data-campo="iti_campoextra1" v-html="html(contatoFormulario, 'iti_campo_extra1')"></p></div><iframe class="map-frame" title="Mapa da Imaginar" loading="lazy" referrerpolicy="no-referrer-when-downgrade" :src="mapEmbedUrl"></iframe></div></section></main>
<a class="whatsapp" aria-label="Falar pelo WhatsApp" :href="whatsappHref" target="_blank" rel="noopener"><span></span></a>
</main> 
</template>

<script>
import axios from 'axios';
import {
  apiUrl,
  contentValue,
  firstImage,
  gridItems,
  loadScreens,
  normalizeInternalLink,
  applyPageMeta,
} from '@/services/contentApi';

export default {
  name: 'ContatoView',
  data() {
    return {
      contatoHero: {},
      contatoFormulario: {},
      form: {
        nome: '',
        whatsapp: '',
        email: '',
        interesse: '',
        mensagem: '',
      },
      sending: false,
      successMessage: '',
      errorMessage: '',
      recaptchaToken: 'recaptcha-desabilitado',
    };
  },
  computed: {
    contactAddress() {
      return this.text(this.contatoFormulario, 'iti_campo_extra1');
    },
    mapEmbedUrl() {
      return 'https://www.google.com/maps?q=' + encodeURIComponent(this.contactAddress) + '&z=16&output=embed';
    },
    addressMapLink() {
      const address = this.text(this.contatoFormulario, 'iti_campo_extra1');
      return 'https://maps.google.com/?q=' + encodeURIComponent(address);
    },
    phoneHref() {
      const value = this.text(this.contatoFormulario, 'iti_campo_extra3');
      const firstPhone = (value.split('/')[0] || '').replace(/\D/g, '');
      return firstPhone ? 'tel:' + firstPhone : '';
    },
    whatsappHref() {
      const value = this.text(this.contatoFormulario, 'iti_campo_extra4');
      const digits = value.replace(/\D/g, '');
      return digits ? 'https://wa.me/55' + digits.replace(/^55/, '') : '';
    },
  },
  created() {
    this.loadContent();
  },
  methods: {
    hideBrokenImage(event) { event.currentTarget.hidden = true; },
    text(source, field, fallback = '') {
      return contentValue(source, field, fallback);
    },
    html(source, field, fallback = '') {
      return contentValue(source, field, fallback);
    },
    image(source, fallback = '') {
      return firstImage(source) || fallback;
    },
    bg(source) {
      const url = firstImage(source);
      return url ? { backgroundImage: 'url("' + url + '")' } : {};
    },
    grids(source) {
      return gridItems(source);
    },
    link(source, field, fallback = '') {
      return normalizeInternalLink(contentValue(source, field, fallback), fallback);
    },
    applyMeta(source) {
      applyPageMeta({
        title: contentValue(source, 'iti_resumo1') || contentValue(source, 'iti_nome'),
        description: contentValue(source, 'iti_descricao1') || contentValue(source, 'iti_resumo1'),
        image: firstImage(source),
      });
    },
    async submitContact() {
      this.successMessage = '';
      this.errorMessage = '';

      if (!this.form.nome) {
        this.errorMessage = 'Nome obrigatorio.';
        return;
      }

      if (!this.form.whatsapp) {
        this.errorMessage = 'WhatsApp obrigatorio.';
        return;
      }

      if (!contentValue(this.contatoFormulario, 'itiReferencia').trim()) {
        this.errorMessage = 'E-mail destinatario nao configurado.';
        return;
      }

      const dadosContato = {
        nome: this.form.nome.trim(),
        whatsapp: this.form.whatsapp.trim(),
        email: this.form.email.trim(),
        interesse: this.form.interesse,
        mensagem: this.form.mensagem.trim(),
      };

      try {
        this.sending = true;
        await axios.post(`${apiUrl}/Public/contact/send`, dadosContato);
        this.successMessage = 'Mensagem enviada com sucesso.';
        this.form = {
          nome: '',
          whatsapp: '',
          email: '',
          interesse: '',
          mensagem: '',
        };
      } catch (error) {
        this.errorMessage = 'Nao foi possivel enviar a mensagem. Tente novamente.';
      } finally {
        this.sending = false;
      }
    },
    async loadContent() {
      const data = await loadScreens([
        {
          ctiId: 30,
          key: "contatoHero",
          multi: false,
        },
        {
          ctiId: 31,
          key: "contatoFormulario",
          multi: false,
        },
      ]);

      Object.assign(this, data);
      this.applyMeta(this.contatoHero);
    },
  },
};
</script>
